import { cn } from '@eliadmin/core/src/utils/style-utils';

export function CoursesSkeleton({ className, amount }: { className?: string; amount?: number }) {
  return (
    <div
      className={cn(
        'grid w-full grid-cols-1 gap-6 md:grid-cols-2 lg:gap-8 xl:grid-cols-3',
        className,
      )}
    >
      {[...Array(amount ?? 3)].map((_, index) => (
        <CourseCardSkeleton key={index} />
      ))}
    </div>
  );
}

export function CourseCardSkeleton() {
  return (
    <div className={cn('col-span-1 w-full', 'animate-pulse')}>
      <div className="relative h-[240px] w-full bg-neutral-100 sm:h-[255px] lg:h-[277px]">
        <div className="absolute left-4 top-4 z-10 flex w-full flex-wrap items-start justify-start gap-2 pr-16">
          <div className="h-6 w-16 bg-white" />
          <div className="h-6 w-32 bg-white" />
        </div>
        <div className="absolute right-4 top-4 z-10 h-12 w-12 bg-white" />
      </div>
      <div className="flex h-[34px] w-full items-center justify-start gap-2 bg-neutral-200/50 px-4">
        <div className="h-4 w-4 bg-white" />
        <div className="h-4 w-40 bg-white" />
      </div>
      <div className="flex w-full flex-col items-start justify-start gap-3 bg-[#F6F6F6] p-4 sm:gap-4 sm:p-5 md:p-6">
        <div className="flex w-full flex-col items-start justify-start gap-2">
          <div className="h-5 w-[98%] bg-white md:h-6" />
          <div className="h-5 w-[77%] bg-white md:h-6" />
        </div>
        <div className="flex w-full items-center justify-start gap-2">
          <div className="min-h-10 min-w-10 rounded-full border-2 border-white bg-white object-cover object-center" />
          <div className="flex w-full flex-col items-start justify-start gap-1.5">
            <div className="h-3 w-20 bg-white" />
            <div className="h-5 w-[70%] bg-white" />
          </div>
        </div>
        <div className="flex w-full items-center justify-start gap-2 sm:gap-3 md:gap-4">
          <div className="flex items-center justify-start gap-2">
            <div className="min-h-6 min-w-6 bg-white" />
            <div className="h-4 w-10 bg-white" />
          </div>
          <div className="flex items-center justify-start gap-2">
            <div className="min-h-6 min-w-6 bg-white" />
            <div className="h-4 w-20 bg-white" />
          </div>
          <div className="flex items-center justify-start gap-2">
            <div className="min-h-6 min-w-6 bg-white" />
            <div className="h-4 w-6 bg-white" />
          </div>
        </div>
      </div>
    </div>
  );
}
